import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithRefreshTokenHandler } from "../authFetchBaseQuery";
import { API_GET_CUSTOM_FIELDS } from "../ApiConstants";
import { IMerchantCustomField } from "../../types/types";

export const customFieldApi = createApi({
  reducerPath: "customFieldApi",
  baseQuery: baseQueryWithRefreshTokenHandler,
  keepUnusedDataFor: 0,
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    getMerchantCustomFields: builder.query<IMerchantCustomField[], string>({
      query: (merchantId) => ({
        url: `${API_GET_CUSTOM_FIELDS}/${merchantId}`,
      }),
    }),
  }),
});

export const { useGetMerchantCustomFieldsQuery } = customFieldApi;
